
            import { Injectable } from '@angular/core';
            import { RockService } from '../rock.service';
            import { RockFieldConfigurationValue, RockModelAttribute, RockModelAttributeQualifier, RockModelAttributeValue, RockModelAttributeValueHistorical, RockModelCategory, RockModelEntityType, RockModelFieldType, RockWebCacheAttributeCache, RockWebCacheAttributeValueCache} from './AttributeValues.models';

            @Injectable()
            export class AttributeValuesService extends RockService {
            
                override entityType = 'AttributeValues';
            
                    /**
                     * Queryable GET endpoint
                     */
                    GetAttributeValues() {
                        return this.get(`AttributeValues`);
                    }

                    /**
                     * POST endpoint. Use this to add a record
                     */
                    PostAttributeValues(value: RockModelAttributeValue) {
                        return this.post(`AttributeValues`, value);
                    }

                    /**
                     * GET endpoint to get a single record
                     */
                    GetAttributeValuesByid(id: number) {
                        return this.get(`AttributeValues/${id}`);
                    }

                    /**
                     * PUT endpoint. Use this to update a record
                     */
                    PutAttributeValuesByid(id: number, value: RockModelAttributeValue) {
                        return this.put(`AttributeValues/${id}`, value);
                    }

                    /**
                     * DELETE endpoint. To delete the record
                     */
                    DeleteAttributeValuesByid(id: number) {
                        return this.delete(`AttributeValues/${id}`);
                    }

                    /**
                     * PATCH endpoint. Use this to update a subset of the properties of the record
                     */
                    PatchAttributeValuesByid(id: number, values: object) {
                        return this.patch(`AttributeValues/${id}`, values);
                    }

                    /**
                     * POST an attribute value. Use this to set an attribute value for the record
                     */
                    PostAttributeValuesAttributeValueByid(id: number) {
                        return this.post(`AttributeValues/AttributeValue/${id}`);
                    }

                    /**
                     * DELETE to delete the specified attribute value for the record
                     */
                    DeleteAttributeValuesAttributeValueByid(id: number) {
                        return this.delete(`AttributeValues/AttributeValue/${id}`);
                    }

                    /**
                     * Gets a list of objects represented by the selected data view
                     */
                    GetAttributeValuesDataViewByid(id: number) {
                        return this.get(`AttributeValues/DataView/${id}`);
                    }

                    /**
                     * undefined
                     */
                    GetAttributeValuesFollowedItems() {
                        return this.get(`AttributeValues/FollowedItems`);
                    }

                    /**
                     * undefined
                     */
                    GetAttributeValuesGetByAttributeValue() {
                        return this.get(`AttributeValues/GetByAttributeValue`);
                    }

                    /**
                     * Determines if the entity id is in the data view
                     */
                    GetAttributeValuesInDataViewBydataViewIdByentityId(dataViewId: number, entityId: number) {
                        return this.get(`AttributeValues/InDataView/${dataViewId}/${entityId}`);
                    }

                    /**
                     * Launches a workflow. And optionally passes the entity with selected id as the entity for the workflow
                     */
                    PostAttributeValuesLaunchWorkflowByid(id: number, workflowAttributeValues: object) {
                        return this.post(`AttributeValues/LaunchWorkflow/${id}`, workflowAttributeValues);
                    }

                    /**
                     * Sets the Context Cookie to the specified record. Use this to set the Campus Context, Group Context, etc
                     */
                    PutAttributeValuesSetContextByid(id: number) {
                        return this.put(`AttributeValues/SetContext/${id}`);
                    }

                    /**
                     * Sets the Context Cookie to the specified record. Use this to set the Campus Context, Group Context, etc
                     */
                    OptionsAttributeValuesSetContextByid(id: number) {
                        return this.options(`AttributeValues/SetContext/${id}`);
                    }

}